export default __webpack_public_path__ + "static/media/about.829be21e.jpg";